import { injectGlobal } from "@emotion/css";

injectGlobal`
    .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {
        font-family: 'Noto sans thai', 'Noto sans';
        font-size: 18px !important;
        width: 250px;
        height: 55px;
        padding: 15px 30px !important;
    }

    .ant-dropdown-menu {
        border-radius: 8px !important;
    }
`;
